export default {
    space: 'swfnnffmifl3',
    accessToken: 'FzTEBXL_vQXo2tmX-blhVNja1syT8mFt5rRKGQa3QTk'
}